"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _reactRedux = require("react-redux");
var _LocalState = _interopRequireDefault(require("../../../../../LocalState"));
var _selectors = require("../../store/selectors");
var _actions = require("../../store/actions");
var _helpers = require("../../store/helpers");
var _excluded = ["countryID", "children", "id", "type", "parentID", "formik"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var groupByType = function groupByType(flattenedTree) {
  return R.groupBy(R.prop('type'), flattenedTree);
};
var getIDs = function getIDs(list) {
  return R.map(R.prop('id'), list);
};
var withProps = function withProps(Component) {
  var WithGeoTreeItemProps = function WithGeoTreeItemProps(_ref) {
    var countryID = _ref.countryID,
      children = _ref.children,
      id = _ref.id,
      type = _ref.type,
      parentID = _ref.parentID,
      formik = _ref.formik,
      props = _objectWithoutProperties(_ref, _excluded);
    var values = formik.values,
      setFieldValue = formik.setFieldValue;
    var hasChildren = props.hasChildren;
    var paramName = (0, _helpers.getQueryParamByType)(type);
    var value = values[paramName],
      cities = values[_fn.QUERY_PARAMS.CITIES],
      provinces = values[_fn.QUERY_PARAMS.PROVINCES],
      districts = values[_fn.QUERY_PARAMS.DISTRICTS];
    var dispatch = (0, _reactRedux.useDispatch)();
    var getGeoTreeByIDSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getGeoTreeByID)(), [{
        id: id,
        key: countryID
      }]);
    }, [id, countryID]);
    var geoTreeByID = (0, _reactRedux.useSelector)(getGeoTreeByIDSelector);
    var hasActiveChildren = (0, _react.useMemo)(function () {
      return Boolean(geoTreeByID) && R.call(R.pipe(_helpers.flattenTree, (0, _helpers.createFillChecker)(cities, districts, provinces)), geoTreeByID);
    }, [cities, districts, geoTreeByID, provinces]);
    var active = R.includes(id, value);
    var handleChange = (0, _react.useCallback)(function () {
      var _ref2 = hasChildren ? R.call(R.pipe(_helpers.flattenTree, groupByType, function (_ref4) {
          var _ref4$city = _ref4.city,
            city = _ref4$city === void 0 ? [] : _ref4$city,
            _ref4$province = _ref4.province,
            province = _ref4$province === void 0 ? [] : _ref4$province,
            _ref4$district = _ref4.district,
            district = _ref4$district === void 0 ? [] : _ref4$district;
          return [{
            baseValues: cities,
            mbNextValues: getIDs(city)
          }, {
            baseValues: provinces,
            mbNextValues: getIDs(province)
          }, {
            baseValues: districts,
            mbNextValues: getIDs(district)
          }];
        }, R.map(function (_ref5) {
          var baseValues = _ref5.baseValues,
            mbNextValues = _ref5.mbNextValues;
          return active ? R.filter(function (ownID) {
            return !R.includes(ownID, mbNextValues);
          }, baseValues) : R.concat(baseValues, mbNextValues);
        })), geoTreeByID) : R.map(function (_ref6) {
          var ownParamName = _ref6.ownParamName,
            items = _ref6.items;
          return ownParamName === paramName ? active ? R.without([id], items) : R.append(id, items) : items;
        }, [{
          ownParamName: _fn.QUERY_PARAMS.CITIES,
          items: cities
        }, {
          ownParamName: _fn.QUERY_PARAMS.PROVINCES,
          items: provinces
        }, {
          ownParamName: _fn.QUERY_PARAMS.DISTRICTS,
          items: districts
        }]),
        _ref3 = _slicedToArray(_ref2, 3),
        nextCities = _ref3[0],
        nextProvinces = _ref3[1],
        nextDistricts = _ref3[2];
      setFieldValue(_fn.QUERY_PARAMS.CITIES, nextCities);
      setFieldValue(_fn.QUERY_PARAMS.PROVINCES, nextProvinces);
      setFieldValue(_fn.QUERY_PARAMS.DISTRICTS, nextDistricts);
      dispatch((0, _actions.autoSelectByParentID)(countryID, parentID, nextCities, nextProvinces, nextDistricts, setFieldValue));
    }, [active, cities, countryID, dispatch, districts, geoTreeByID, hasChildren, id, paramName, parentID, provinces, setFieldValue]);
    return /*#__PURE__*/_react.default.createElement(_LocalState.default, {
      initial: hasActiveChildren
    }, function (open, setOpen) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
        checked: active,
        hasActiveChildren: hasActiveChildren,
        open: open,
        onChange: handleChange,
        onClick: function onClick() {
          return setOpen(!open);
        }
      })), children(open));
    });
  };
  WithGeoTreeItemProps.defaultProps = {
    children: R.always(null)
  };
  WithGeoTreeItemProps.propTypes = {
    countryID: _propTypes.default.string.isRequired,
    hasChildren: _propTypes.default.bool.isRequired,
    id: _propTypes.default.number.isRequired,
    parentID: _propTypes.default.number.isRequired,
    type: _propTypes.default.string.isRequired,
    children: _propTypes.default.func
  };
  return (0, _formik.connect)(WithGeoTreeItemProps);
};
var _default = exports.default = withProps;